export const LAST_DAY = "last-day";
export const LAST_WEEK = "last-week";
export const LAST_MONTH = "last-month";
export const LAST_THREE_MONTHS = "last-three-months";
export const LAST_SIX_MONTHS = "last-six-months";
